import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { fetchComboData } from '../../services/api';

const EditModal = ({ record, onClose, onSave }) => {
  const [formData, setFormData] = useState({ ...record });
  const [suppliers, setSuppliers] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setFormData({ ...record });
    fetchSuppliers();
    fetchCategories();
  }, [record]);

  const fetchSuppliers = async () => {
    try {
      const supplierData = await fetchComboData('supplier', 'name');
      console.log('Modal suppliers data:', supplierData);
      setSuppliers(supplierData || []);
    } catch (error) {
      console.error('Error fetching suppliers:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const categoryData = await fetchComboData('brand', 'name');
      setCategories(categoryData || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const renderField = (key) => {
    // Skip id field
    if (key === 'id') return null;

    // Render brand dropdown
    if (key === 'brand') {
      return (
        <Form.Group key={key} className="mb-3">
          <Form.Label>Brand/Category</Form.Label>
          <Form.Select
            name={key}
            value={formData[key] || ''}
            onChange={handleChange}
          >
            <option value="">Select Brand</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      );
    }

    // Render sponsor_name dropdown
    if (key === 'sponsor_name') {
      return (
        <Form.Group key={key} className="mb-3">
          <Form.Label>Sponsor Name</Form.Label>
          <Form.Select
            name={key}
            value={formData[key] || ''}
            onChange={handleChange}
          >
            <option value="">Select Sponsor</option>
            {suppliers.map((supplier) => (
              <option key={supplier.id} value={supplier.name}>
                {supplier.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      );
    }

    // Default text input for other fields
    return (
      <Form.Group key={key} className="mb-3">
        <Form.Label style={{ textTransform: 'capitalize' }}>
          {key.replace(/_/g, ' ')}
        </Form.Label>
        <Form.Control
          type="text"
          name={key}
          value={formData[key] || ''}
          onChange={handleChange}
        />
      </Form.Group>
    );
  };

  return (
    <Modal show={true} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Record</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(formData).map((key) => renderField(key))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
